import { createSelector } from '@reduxjs/toolkit';
import { State } from '../../../store/state';

const notificationIdsSelector = (state: State) => state.notification.notifications.ids;
const notificationEntitiesSelector = (state: State) => state.notification.notifications.entities;

export const notificationsSelector = createSelector(
  [notificationIdsSelector, notificationEntitiesSelector],
  (ids, entities) => ids.map((id) => entities[id]),
);

export const unreadNotificationsSelector = (state: State) => state.notification.unreadNotifications;
export const noMoreSelector = (state: State) => state.notification.noMore;
export const pageSelector = (state: State) => state.notification.page;
export const errorCodeSelector = (state: State) => state.notification.errorCode;
export const loadingSelector = (state: State) => state.notification.loading;
export const unreadLoadingSelector = (state: State) => state.notification.unreadLoading;
export const unreadLoadedSelector = (state: State) => state.notification.unreadLoaded;
